import { render } from "./FrameModal.vue?vue&type=template&id=1b6fcf56"
import script from "./FrameModal.vue?vue&type=script&lang=js"
export * from "./FrameModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__